import Model from "./base/model";

class Fintech extends Model{
  resourceName() {
    return "fintechs";
  }

  fields() {
    return {
      social_reason: "",
      fantasy_name:"",
      cnpj: "",
      municipal_registration: "",
      state_registration: "",
      telephone: "",
      type: "",
      responsible: { jsonApi: "hasOne", type: "users"},
      address: { jsonApi: "hasOne", type: "adresses" },
      settings: { jsonApi: "hasOne", type: "settings" },
    };
  }
}

export default new Fintech();
